const Timezones = [
  { value: -12, name: '(GMT-12:00) International Date Line West' },
  { value: -11, name: '(GMT-11:00) Midway Island, Samoa' },
  { value: -10, name: '(GMT-10:00) Hawaii' },
  { value: -9, name: '(GMT-09:00) Alaska' },
  { value: -8, name: '(GMT-08:00) Pacific Time' },
  { value: -7, name: '(GMT-07:00) Mountain Time' },
  { value: -6, name: '(GMT-06:00) Central Time' },
  { value: -5, name: '(GMT-05:00) Eastern Time' },
  { value: -4, name: '(GMT-04:00) Atlantic Time' },
  { value: -3, name: '(GMT-03:00) Brasilia' },
  { value: -2, name: '(GMT-02:00) Mid-Atlantic' },
  { value: -1, name: '(GMT-01:00) Azores' },
  { value: 0, name: '(GMT+00:00) GMT' },
  { value: 1, name: '(GMT+01:00) Lisbon, Dublin, London' },
  { value: 2, name: '(GMT+02:00) Warsaw, Berlin' },
  { value: 3, name: '(GMT+03:00) Moscow, Minsk' },
  { value: 4, name: '(GMT+04:00) Baku, Yerevan' },
  { value: 5, name: '(GMT+05:00) Yekaterinburg, Tashkent' },
  { value: 6, name: '(GMT+06:00) Almaty, Astana' },
  { value: 7, name: '(GMT+07:00) Krasnoyarsk, Novosibirsk' },
  { value: 8, name: '(GMT+08:00) Irkutsk, Beijing' },
  { value: 9, name: '(GMT+09:00) Yakutsk, Tokyo' },
  { value: 10, name: '(GMT+10:00) Vladivostok, Canberra' },
  { value: 11, name: '(GMT+11:00) Magadan, New Caledonia' },
  { value: 12, name: '(GMT+12:00) Fiji, Kamchatka' }
];

export default Timezones;
